import React from 'react';
import { AlertTriangle } from 'lucide-react';

export default function ValidationIssues({ unresolvedIssues }) {
  if (!unresolvedIssues || unresolvedIssues.length === 0) return null;

  const scrollToItem = (itemIndex) => {
    const el = document.getElementById(`line-item-${itemIndex}`);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  };

  return (
    <div id="validation-issues-panel" className="bg-amber-500/10 border border-amber-500/20 rounded-xl p-4">
      <h3 className="text-xs font-semibold text-amber-400 uppercase tracking-wider mb-2 flex items-center gap-2">
        <AlertTriangle className="w-3 h-3" />
        Items Need Attention
      </h3>
      <ul className="text-sm text-slate-300 space-y-1">
        {unresolvedIssues.map((issue, idx) => (
          <li key={idx} className="flex items-start gap-2">
            <span className="text-amber-400">•</span>
            {issue.itemIndex !== null ? (
              <span
                className="cursor-pointer hover:text-amber-400 hover:underline transition-colors"
                onClick={() => scrollToItem(issue.itemIndex)}
              >
                {issue.text}
              </span>
            ) : (
              <span>{issue.text}</span>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
}
